<template>
  <section v-if="!editing">
    <AdvanceRequisiteRulesReadonly
      class="req"
      :value="value.rules"
      :level="level"
    />
    <label class="bmd-label-static my-2">Additional Comments</label>
    <FormWysiwyg
      v-if="value.freeFormText"
      :disabled="true"
      class="mb-2"
      :value="value.freeFormText"
    />
    <AppButton
      v-if="!disabled"
      @click="$emit('editing',true)"
    >
      <AppIcon
        name="edit"
        class="mr-1"
      /> Edit
    </AppButton>
  </section>
  <section v-else>
    <AppSwitch
      v-if="isFieldVisible('showInCatalog')"
      :disabled="!isFieldEditable('showInCatalog')"
      :value="(value.showInCatalog === undefined)?showInCatalogDefaultValue:value.showInCatalog"
      :label="`Show in ${$localize('catalog')}`"
      @input="updateRequisite('showInCatalog', $event)"
    />
    <FormText
      label="Name"
      placeholder="Requirement Name"
      :value="value.name"
      class="mb-2"
      @input="updateRequisite('name', $event)"
    />
    <AdvanceRequisiteRules
      :value="value.rules"
      class="mb-2"
      @input="updateRequisite('rules', $event)"
    />
    <FormWysiwyg
      class="mb-2"
      :value="value.freeFormText"
      label="Additional Comments"
      placeholder="Add any additional comments..."
      @input="updateRequisite('freeFormText', $event)"
    />
    <div class="d-flex">
      <AppButton
        variant="danger"
        @click="$emit('delete')"
      >
        <AppIcon
          name="remove_circle"
          class="mr-1"
        />Remove
      </AppButton>
      <AppButton
        class="ml-2"
        @click="$emit('editing',false)"
      >
        <AppIcon
          name="close"
          class="mr-1"
        /> Stop Editing
      </AppButton>
    </div>
  </section>
</template>

<script>
import AdvanceRequisiteRules from './AdvanceRequisiteRules'
import AdvanceRequisiteRulesReadonly from './AdvanceRequisiteRulesReadonly'
import FormWysiwyg from '@/components/Forms/FormWysiwyg'
import FormText from '@/components/Forms/FormText'
import { userHasAnyAllowedRole } from '@shared/permissions/validators'
import { mapGetters } from 'vuex'
import FormMixin from '@/components/Forms/FormMixin'
import { SHOW_IN_CATALOG_DEFAULT_VALUE } from '@shared/constants/requisites'

export default {
  mixins: [ FormMixin ],
  components: {
    AdvanceRequisiteRules,
    AdvanceRequisiteRulesReadonly,
    FormWysiwyg,
    FormText,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },

  setup (props, { root }) {

    const requisitesAdvancedConfig = props?.config?.fields?.requisitesAdvanced || {}
    const requirementFieldsConfiguration = requisitesAdvancedConfig?.config?.fields || {}

    return {
      requirementFieldsConfiguration,
    }
  },
  computed: {
    ...mapGetters([ 'user' ]),
    showInCatalogDefaultValue () {
      if (!this.requirementFieldsConfiguration) return SHOW_IN_CATALOG_DEFAULT_VALUE

      const fieldConfig = this.requirementFieldsConfiguration['showInCatalog'] || {}

      if (!fieldConfig.config) { return SHOW_IN_CATALOG_DEFAULT_VALUE }

      return fieldConfig.config.defaultValue
    },

  },
  methods: {
    isFieldVisible (fieldKey) {
      if (!this.requirementFieldsConfiguration) return false

      const fieldConfig = (this.requirementFieldsConfiguration[fieldKey] || {})['rolesAllowedToSee']
      return userHasAnyAllowedRole(this.user, null, fieldConfig)
    },
    isFieldEditable (fieldKey) {
      if (!this.requirementFieldsConfiguration) return false

      const fieldConfig = (this.requirementFieldsConfiguration[fieldKey] || {})['rolesAllowedToEdit']
      return userHasAnyAllowedRole(this.user, null, fieldConfig)
    },
    updateRequisite (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
}
</script>
